import { addAuditLog } from '../../action/ClientActions'

export const addAuditLogFunc = (action, actionData) => {
	const params = {
		action,
		action_data: actionData,
	}
	addAuditLog(params)
		.then((res, err) => {
		})
		.catch((error) => {
			console.log('!addAuditLog error:', error)
		})
}
